// covered-by: frontends/carrie/src/ask-v2/__tests__/import-wall.test.ts
import { Spinner } from "@radix-ui/themes";
import { Suspense, lazy, type ComponentProps, type ReactNode } from "react";

const LazySkillDocumentsPanel = lazy(() =>
  import("../../ask-puntt/components/SkillDocumentsPanel").then((module) => ({
    default: module.SkillDocumentsPanel,
  })),
);

const LazyRequiredInputsEditor = lazy(() =>
  import("../../ask-puntt/components/RequiredInputsEditor").then((module) => ({
    default: module.RequiredInputsEditor,
  })),
);

const LazyAskPunttDesktopNotificationsToggleControl = lazy(() =>
  import("../../ask-puntt/components/AskPunttDesktopNotificationsToggleControl").then(
    (module) => ({
      default: module.AskPunttDesktopNotificationsToggleControl,
    }),
  ),
);

function AskPunttSettingsWidgetFallback() {
  return <Spinner data-testid="ask-puntt-settings-widget-loading" />;
}

function withAskPunttSettingsSuspense(node: ReactNode) {
  return (
    <Suspense fallback={<AskPunttSettingsWidgetFallback />}>{node}</Suspense>
  );
}

export function SkillDocumentsPanel(
  props: ComponentProps<typeof LazySkillDocumentsPanel>,
) {
  return withAskPunttSettingsSuspense(<LazySkillDocumentsPanel {...props} />);
}

export function RequiredInputsEditor(
  props: ComponentProps<typeof LazyRequiredInputsEditor>,
) {
  return withAskPunttSettingsSuspense(<LazyRequiredInputsEditor {...props} />);
}

export function AskPunttDesktopNotificationsToggleControl(
  props: ComponentProps<typeof LazyAskPunttDesktopNotificationsToggleControl>,
) {
  return withAskPunttSettingsSuspense(
    <LazyAskPunttDesktopNotificationsToggleControl {...props} />,
  );
}
